import { NextList } from "../../Paginator/NextList";
import {
    FrontWebPodcastProgramModel,
    FrontWebSearchResultEpisodesModel,
    GetApiPodcastEpisodesOrderByEnum
} from "../../../generated";
import routes from "../../../utils/routes";
import { useState} from "react";
import { EpisodeRowList } from "./EpisodeRowList";
import { useRadio} from "../../../contexts/useRadio";
import {useProgramEpisodesKey} from "../../../queriesKeys/useProgramEpisodesKey";
import {useQuery} from "@tanstack/react-query";



type Props = {
    episodes: FrontWebSearchResultEpisodesModel,
    program: FrontWebPodcastProgramModel
    page: number,
    byClick?: boolean,
    orderBy: GetApiPodcastEpisodesOrderByEnum
}

export const EpisodesPager = ({
                             episodes,
                             program,
                             page,
                             orderBy,
                         }: Props) => {

    const hasRadio = useRadio();
    const [nPage, setNPage] = useState(page);
    const result = useQuery({ ...useProgramEpisodesKey(nPage+1, program.slug, orderBy), enabled: false})

    return <>
        <NextList
            items={episodes.result}
            page={page}
            byClick={true}
            hrefBuilder={(pageIndex) => {
                const p = (pageIndex > 1)  ? { page: `${pageIndex}` } : { };
                if (hasRadio) {
                    // @ts-ignore
                    return routes.radio_program_detail(hasRadio.slug, program.slug, orderBy, {
                       ...p
                    }, "episodes");
                }
                // @ts-ignore
                return routes.program_detail(program.slug, orderBy, {
                    ...p
                }, "episodes");
            }}
            loader={async (page) => {
                const res = await result.refetch();
                setNPage(nPage + 1);
                return res.data!;
            }}
            nextText={"Načíst další episody"}
            pages={episodes.pages}
            render={(episodes) => <EpisodeRowList className={"mb-48px"} items={episodes}/>}
        />
    </>
}